


























































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import moment from "moment";

import {
  FiltroServicosSemPrestadorModel,
  SolicitacaoModel,
  FinalizarSolicitacaoModel,
  statusList,
  ServicoDetalhadoModel,
  DadosClienteModel,
  SolicitacaoSemPrestadorModel
} from "@/models/solicitacoes";
import DetalheSolicitacao from "./DetalheSolicitacao.vue";

import { tipoServicoList } from "@/models/solicitacoes/TipoServicoModel";

import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";

import { DadosModal } from "@/components/modal/DadosModal";
import GsModal from "@/components/modal/GsModal.vue";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

import { servicoModule } from "@/store/servico/ServicoModule";
import { TipoModalEnum } from "@/components/modal/TipoModalEnum";

@Component({
  components: {
    GsModal,
    GsModalDialog,
    ValidationObserver,
    ValidationProvider,
    DetalheSolicitacao
  }
})

export default class AcompanhamentoSolicitacoes extends Vue {
  $refs!: {
    filtroObserver: InstanceType<typeof ValidationObserver>;
    motivoCancelamentoObserver: InstanceType<typeof ValidationObserver>;
    acceptObserver: InstanceType<typeof ValidationObserver>;
  };

  cabecalho = [
    { text: "Nome do cliente", value: "nomeCliente", sortable: false, width: "15%" },
    { text: "Telefone", value: "telefone", sortable: false },
    {
      text: "Email",
      value: "email",
      sortable: false,
      width: "15%"
    },
    { text: "Cidade", value: "enderecoCompleto", sortable: false },
    //{ text: "Origem", value: "enderecoCompleto", sortable: false, width: "15%"  },
    //{ text: "Destino", value: "enderecoCompleto", width: "15%", sortable: false },
    { text: "Serviço solicitado", value: "tipoServico", sortable: false },
    { text: "Data/hora da solicitação", value: "dataCriacao", sortable: false }
  ];
  
  _timerId: any = null;
  tempoAtualizacaoPagina: number = 10000;

  reenviarServico = false;
  idPrestadorAceitar = 0;
  idServicoAceitar = 0;
  nomeMotorista = "";
  placaVeiculo = "";
  tempoEstimado = "";

  // Dialog
  showDialog = false;
  dialogType = "";
  dialogTitle = "";
  dialogMessage = "";
  loading = false;

  // Accept Dialog
  showAcceptDialog = false;

  listaStatus = statusList;
  listaTipoServico = tipoServicoList;

  isCancelar: boolean = false;
  isFinalizar: boolean = false;

  error = false;
  errorMessage = "";
 
  dadosModal: DadosModal = DadosModal.defaultValue();
  
  detalheSolicitacao: ServicoDetalhadoModel | null = null;
  dadosCliente: DadosClienteModel | null = null;
  resultado: SolicitacaoModel[] = [];
  resultadoSemPrestador: SolicitacaoSemPrestadorModel[] = [];

  servicoAFinalizar: FinalizarSolicitacaoModel = {
    idServico: undefined,
    idPrestador: undefined
  };

  filtro: FiltroServicosSemPrestadorModel = {
    dataAte: moment().format("YYYY-MM-DD"),
    dataDe: moment()
      .add(-1, "day")
      .format("YYYY-MM-DD"),
    paginacao: { 
      itemsPerPage: 15,
      page: 1,
      itemsLength: 0
    }
  };

  descricaoStatus(status: string) {
    let descricao = "";

    statusList.filter(statusStatic => {
      statusStatic.valor.forEach(valor => {
        if (status == valor) {
          descricao = statusStatic?.descricao;
        }
      });
    });
    return descricao;
  }

  mounted() {
    this.pesquisar();
    //this._timerId = setInterval(this.pesquisar, this.tempoAtualizacaoPagina); 
  }

  destroyed() {
    clearInterval(this._timerId);
  }

  @Watch("filtro.paginacao.page")
  @Watch("filtro.paginacao.itemsPerPage")
  observarPaginacao() {
   this.getData();
  }

  get btnColor() {
    return this.dialogType == 'SUCCESS' ? '#00CD96' : 'error';
  }

  get btnText() {
    return this.dialogType == 'SUCCESS' ? 'Ok, entendi' : 'Fechar';
  }

  get dialogImg() {
    return this.dialogType == 'SUCCESS' ? 'success.png' : 'error.png';
  }

  pesquisar() {
    this.filtro.paginacao.page = 1;
    this.getData();
  }

  cancelar() {
    this.dadosModal.aberto = false;
    this.isCancelar = false;
    this.isFinalizar = false;
  }

  getData() {
    this.error = true;
    this.errorMessage = "";
    if (
      !this.filtro.tipoServico &&
      !this.filtro.cidade &&
      (!this.filtro.dataDe || !this.filtro.dataAte)
    ) {
      this.$refs.filtroObserver.setErrors({
        status: "É necessário informar pelo menos um filtro"
      });
    } else {
      this.loading = true;

      servicoModule
        .obterSolicitacoesSemPrestadores(this.filtro)
          .then(res => {            
            this.resultadoSemPrestador = servicoModule.resultadoSolicitacoesSemPrestador?.servicos || [];
            this.filtro.paginacao.itemsLength = 0;
          })
          .catch(err => {
            console.error(err);
            this.error = true;
            this.errorMessage = "Ocorreu uma falha ao buscar as solicitações.";
          })
          .finally(() => {
            this.filtro.paginacao.itemsLength =
            servicoModule.resultadoSolicitacoesSemPrestador?.paginacao.itemsLength || 0;
            this.loading = false;
          });
    }
  }


  gerarRelatorio() {
      this.loading = true;
      ServicosAssistenciaService.gerarRelatorioLogSemPrestadorPDF(this.filtro)
        .then((res) => {
          let fileURL = window.URL.createObjectURL(new Blob([res.data]));

          let fileLink = document.createElement("a");

          fileLink.href = fileURL;

          fileLink.setAttribute("download", "relatorio_logs_servico_sem_prestador.pdf");

          document.body.appendChild(fileLink);

          fileLink.click();

          this.loading = false;
        })
        .catch((err) => {
          this.openDialog('Erro', err.message, 'Error');
          this.loading = false;
        });

      //this.limparformulario();
  }

  gerarRelatorioExcel() {
      this.loading = true;
      ServicosAssistenciaService.gerarRelatorioLogSemPrestadorXLS(this.filtro)
        .then((res) => {
          let fileURL = window.URL.createObjectURL(new Blob([res.data]));

          let fileLink = document.createElement("a");

          fileLink.href = fileURL;

          fileLink.setAttribute("download", "relatorio_logs_servico_sem_prestador.xls");

          document.body.appendChild(fileLink);

          fileLink.click();

          this.loading = false;
        })
        .catch((err) => {
          this.openDialog('Erro', err.message, 'Error');
          this.loading = false;
        });

      //this.limparformulario();
    }

  fecharModal() {
    const tipo = this.dadosModal.titulo;
    this.detalheSolicitacao = null;
    this.dadosCliente = null;
    this.dadosModal = DadosModal.defaultValue();
    this.servicoAFinalizar = {};
    if (tipo == "Sucesso") {
      this.pesquisar();
    }
  }

  private openDialog(title: string, message: string, dialogType: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  closeDialog() {
    if (this.dialogType == 'SUCCESS') {
      this.pesquisar();
    }
    this.showDialog = false;
  }

}
